import {createAsyncThunk} from '@reduxjs/toolkit';
import {BreadcrumbName} from 'common/src/modules/breadcrumbs/breadcrumbs.enums';
import {contentFeedItemsApi} from 'common/src/modules/contentFeedItems/contentFeedItems.api';
import {
  setDraftItems,
  setDraftItemsError,
  setDraftItemsLoading,
  setLoadedDraftItemsFeedId,
} from '../reducers/contentFeedDraftItems.slice';

interface LoadDraftItemsPayload {
  feedId: number;
  forceReload?: boolean;
}

export const loadDraftItems = createAsyncThunk(
  `${BreadcrumbName.ContentFeedPage}/loadDraftItems`,
  async ({feedId, forceReload}: LoadDraftItemsPayload, {dispatch, getState}) => {
    const state = getState() as {contentFeedPage: {draftItems: {loadedFeedId: number | null}}};

    if (!forceReload && state.contentFeedPage.draftItems.loadedFeedId === feedId) {
      return;
    }

    try {
      dispatch(setDraftItemsLoading(true));
      dispatch(setDraftItemsError(null));

      const items = await contentFeedItemsApi.getDraftItems(feedId);
      dispatch(setDraftItems(items));
      dispatch(setLoadedDraftItemsFeedId(feedId));
    } catch (error) {
      const message = error instanceof Error ? error.message : 'Failed to load draft items';
      dispatch(setDraftItemsError(message));
      throw error;
    } finally {
      dispatch(setDraftItemsLoading(false));
    }
  },
);
